// extracted by mini-css-extract-plugin
export var body = "_34-1";
export var bodyPadded = "_34-2";
export var chevron = "_34-4";
export var chevronOpen = "_34-5";
export var header = "_34-0";
export var icon = "_34-3";